module.exports = __webpack_public_path__ + "static/media/ellee_bakery.881f4b82.png";